import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "VR楽器 \"isonote\""
const scope = "個人制作"
const str1 = "和音や音階などの音楽の構造を空間的・身体的・直感的に理解しながら、誰でも美しい演奏ができる「VR楽器」を構想、制作した。"
const str2 = "12平均律の各音を関係が深いものが近接するように均質に配置し、2本のバチで同時に最大6音を鳴らすことができるように打面を重ね合わせることで、さまざまな和音や音階の演奏を可能にした。スケールやモードといった音楽の概念を、距離やストロークといった空間・身体言語へと変換することができた。"
const str3 = <a href="https://note.com/banjo_kanna/n/na4b691aee49e" target="_blank" rel="noreferrer"><font color="#ff00ff">for more info.</font></a>

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.isonote01.childImageSharp.original.src}
          pageimgw={data.isonote01.childImageSharp.original.width}
          pageimgh={data.isonote01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote05.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/isonote06.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
            <p>{str3}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  isonote01: file(relativePath: {eq: "isonote01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
